import { IApplicationState } from '../../types/redux';
import { isExperimentActive } from '../../utils/isExperimentActive';
import { selectExperiments } from './selectExperiments';
import { WEB_TO_APP_BANNER } from '../../constants/experiments';

export function selectIsWebToAppBannerExperimentEnabled(state: IApplicationState): boolean {
  const experiments = selectExperiments(state);

  return isExperimentActive(experiments, WEB_TO_APP_BANNER, 'B');
}
